import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Checkbox,
  InfoIcon,
  Input,
  InputPhone,
  Label,
  Text,
  Tooltip,
} from '@mercai/clever'
import { DocumentDragDropCard } from '@/components'

import { FormLegalRepresentativeProps } from './form-legal-representative.type'
import styles from './form-legal-representative.module.css'

const FormLegalRepresentative = ({
  profile,
  data,
  onChange,
}: FormLegalRepresentativeProps) => {
  const { t } = useTranslation('screenProfileShow')

  const uploadFileSuccess = (fileField: string, file: string) => {
    onChange((prev) => ({
      ...prev,
      [fileField]: file,
    }))
  }

  const handleInputChange =
    (fieldName: string) => (fieldValue: string | boolean) => {
      onChange((prev) => ({ ...prev, [fieldName]: fieldValue }))
    }

  useEffect(() => {
    if (profile) {
      onChange({
        name: profile?.legalRepresentative?.name || '',
        email: profile?.legalRepresentative?.email || '',
        phone: profile?.legalRepresentative?.phone || '',
        addToAccount: profile?.legalRepresentative?.addToAccount || false,
        idDocument: profile?.legalRepresentative?.idDocument || '',
        powerOfAttorney: profile?.legalRepresentative?.powerOfAttorney || '',
      })
    }
  }, [profile])

  return (
    <fieldset className={styles.core}>
      <div className={styles['input-item']}>
        <Label className={styles.label} htmlFor="name">
          {t('formLegalRepresentativeNameField')}
        </Label>
        <Input
          value={data.name}
          onChange={handleInputChange('name')}
          id="name"
          placeholder="Juan Pérez Rodríguez"
        />
      </div>

      <div className={styles['input-item']}>
        <Label className={styles.label} htmlFor="email">
          {t('formLegalRepresentativeCorreoField')}
        </Label>
        <Input
          value={data.email}
          onChange={handleInputChange('email')}
          id="email"
          placeholder="juan@gmail.com"
        />
      </div>

      <div className={styles['input-item']}>
        <Label className={styles.label}>
          {t('formLegalRepresentativePhoneField')}
        </Label>
        <InputPhone
          value={data.phone}
          onChange={handleInputChange('phone')}
          defaultCountry={'mx'}
        />
      </div>

      <div className={styles['tooltip-box']}>
        <Checkbox
          value={data.addToAccount}
          className={styles.checkbox}
          onChange={handleInputChange('addToAccount')}
        >
          <div className={styles['checkbox-text']}>
            {t('formLegalRepresentativeAgregarCuentaField')}{' '}
          </div>
        </Checkbox>

        <Tooltip
          text={t('formLegalRepresentativeAgregarCuentaTooltip')}
          orientation="left"
          className={styles['question-tooltip']}
          widthText="20rem"
          textClassname={styles['tooltip-text']}
        >
          <InfoIcon />
        </Tooltip>
      </div>

      <div className={styles['document-container']}>
        <div className={styles['tooltip-box']}>
          <Text className={styles['document-label']}>
            {t('formLegalRepresentativeIdentificationDocumentLabel')}
          </Text>

          <Tooltip
            text={t('formLegalRepresentativeIdentificationDocumentTooltip')}
            orientation="left"
            className={styles['question-tooltip']}
            widthText="20rem"
            textClassname={styles['tooltip-text']}
          >
            <InfoIcon />
          </Tooltip>
        </div>

        <DocumentDragDropCard
          file={data.idDocument}
          fileField="idDocument"
          uploadFileSuccess={uploadFileSuccess}
          translations={{
            clickToUpload: t('uploadButton'),
            dragFile: t('uploadDrag'),
            sizeFile: t('uploadSize'),
          }}
        />
      </div>

      <div className={styles['document-container']}>
        <Text className={styles['document-label']}>
          {t('formLegalRepresentativePowerDocumentLabel')}
        </Text>

        <DocumentDragDropCard
          file={data.idDocument}
          fileField="powerOfAttorney"
          uploadFileSuccess={uploadFileSuccess}
          translations={{
            clickToUpload: t('uploadButton'),
            dragFile: t('uploadDrag'),
            sizeFile: t('uploadSize'),
          }}
        />
      </div>
    </fieldset>
  )
}

export default FormLegalRepresentative
